import React, { useState } from "react";
import Routes from "./routes";
import { Provider } from "react-redux";
import { OidcProvider } from "redux-oidc";
import BusyContainer from "./busyContainer";
import { ApolloProvider } from "@apollo/react-hooks";
import { ModalContext } from "./Context/ModalContext";

const App = ({ config }) => {
  const { store, client, userManager } = config;
  const [openModal, setOpenModal] = useState(null);

  return (
    <ApolloProvider client={client}>
      <Provider store={store}>
        <OidcProvider store={store} userManager={userManager}>
          <BusyContainer>
            <ModalContext.Provider value={{ openModal, setOpenModal }}>
                <Routes userManager={userManager} />
            </ModalContext.Provider>
          </BusyContainer>
        </OidcProvider>
      </Provider>
    </ApolloProvider>
  );
};

export default App;
